module.exports = __webpack_public_path__ + "media/암모나이트를 만나다.e0bf4f7f.mp4";